import { z } from "zod";

import { CurrencyType } from "@/lib/gql/__generated__/graphql";

import { priceObjectZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

const ERROR_MESSAGES = {
	NAME: {
		MIN: "ディスカウントの名前は必須項目です",
		MAX: "ディスカウントの名前は30文字以内で入力してください",
	},
	DESCRIPTION: {
		MIN: "ディスカウントの説明は必須項目です",
		MAX: "ディスカウントの説明は1000文字以内で入力してください",
	},
	DISCOUNT_CODE: {
		MIN: "ディスカウントコードは必須項目です",
		MAX: "ディスカウントコードは30文字以内で入力してください",
	},
	PRICE_TOTAL_LIMIT_AMOUNT: {
		MIN: "合計上限価格は必須項目です",
	},
	RESOURCE_LOWEST_PRICE_AMOUNT: {
		MIN: "最低提供価格は必須項目です",
	},
};

/**
 * ディスカウントの共通バリデーションスキーマ
 */
export const CommonDiscountInputZodSchema = z.object({
	name: z.string().min(1, { message: ERROR_MESSAGES.NAME.MIN }).max(30, { message: ERROR_MESSAGES.NAME.MAX }),
	description: z
		.string()
		.min(1, { message: ERROR_MESSAGES.DESCRIPTION.MIN })
		.max(1000, { message: ERROR_MESSAGES.DESCRIPTION.MAX }),
	discountCode: z
		.string()
		.min(1, { message: ERROR_MESSAGES.DISCOUNT_CODE.MIN })
		.max(30, { message: ERROR_MESSAGES.DISCOUNT_CODE.MAX }),
	discountPriceTotalLimit: priceObjectZodSchema.nullish(),
	resourceLowestPrice: z.object({
		amount: z
			.number()
			.int()
			.min(0, { message: "金額には0円以上の値を入力してください" })
			.max(10_000_000, { message: "金額には10,000,000円以下の値を入力してください" }),
		currencyType: z.nativeEnum(CurrencyType),
	}),
});
